<template>
  <div class="platform-para-table-wrap">
    <el-button type="primary" @click="addData" style="float: right; margin-bottom: 8px">新增</el-button>
    <el-table
      class="parae-setting-table"
      :data="tableList"
      :max-height="tableMaxHeight"
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.1)"
    >
      <el-table-column label="id" prop="id" width="80"></el-table-column>
      <el-table-column label="唯一标识" prop="afid"></el-table-column>
      <el-table-column v-if="paraType === 'meta'" label="数据集ID" prop="datasetId"></el-table-column>
      <el-table-column v-if="paraType === 'meta'" label="Token" prop="token"></el-table-column>
      <el-table-column v-if="paraType === 'firebase'" label="API Key" prop="apiKey"></el-table-column>
      <el-table-column label="操作" width="160">
        <template slot-scope="scope">
          <el-button class="edit-btn" size="mini" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button type="danger" size="mini" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <platform-para-dialog
      ref="platformParaDialog"
      :para-type="paraType"
      @updateTable="getTableList"
    ></platform-para-dialog>
  </div>
</template>

<script>
import { deletePlatformConfig, getPlatformConfigList } from "@/api/api";
import PlatformParaDialog from "./platformParaDialog.vue";

const PLATFORM_TYPE_MAP = {
  meta: 1,
  firebase: 2,
};

export default {
  name: "platformParaTable",
  components: {
    PlatformParaDialog,
  },
  props: {
    paraType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      tableList: [],
      tableMaxHeight: window.innerHeight - 150,
      loading: false,
    };
  },
  mounted() {
    this.getTableList();
  },
  watch: {
    paraType() {
      this.getTableList();
    },
  },
  methods: {
    getTableList() {
      this.loading = true;
      getPlatformConfigList({
        afid: "",
        platformType: PLATFORM_TYPE_MAP[this.paraType],
      })
        .then((res) => {
          if (res.code === "0000") {
            this.tableList = this.getPlatformListFromResponse(res);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getPlatformListFromResponse(res) {
      const list = res.data || res.list || res.platformConfigs || res.records || [];
      return Array.isArray(list) ? list : [];
    },
    addData() {
      this.$refs.platformParaDialog.showModal(true);
    },
    handleEdit(row) {
      this.$refs.platformParaDialog.showModal(false, row);
    },
    handleDelete(row) {
      this.$confirm("确定删除该平台配置吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        deletePlatformConfig({ id: row.id }).then((res) => {
          if (res.code === "0000") {
            this.$message.success("删除成功");
            this.getTableList();
          }
        });
      }).catch(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
.platform-para-table-wrap {
  height: 100%;
}
</style>
